import React from "react";
import { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Services } from "../../api/Services";
const Trainings = ({ activeid }) => {
  const [trainermodal, setTrainerModal] = useState(false);
  const [editFieldModal, setEditFieldModal] = useState(false);
  const [etrainermodal, seteTrainerModal] = useState(false);
  const [newFieldsModal, setNewFieldsModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [fields, setFields] = useState([]);
  const [efields, seteFields] = useState([]);
  const [editFieldId, setEditFieldId] = useState("");
  const [formValues, setFormValues] = useState([]);
  const [eformValues, seteFormValues] = useState([]);
  //new fields state
  const [fieldName, setFieldName] = useState("");
  const [fieldType, setFieldType] = useState("");
  const [fieldId, setFieldId] = useState("");
  const [isEdit, setIsEdit] = useState(false);

  // states for training fields values
  const [fieldsValues, setFieldsValues] = useState([]);
  //set form values

  const handleInputChange = (fieldId, value) => {
    setFormValues((prevValues) => {
      // Check if the field is already in formValues
      const existingFieldIndex = prevValues.findIndex(
        (field) => field.field_id === fieldId
      );

      // If the field is found, update its value; otherwise, add a new object to the array
      const updatedValues = [...prevValues];
      if (existingFieldIndex !== -1) {
        updatedValues[existingFieldIndex] = {
          field_id: fieldId,
          field_value: value,
        };
      } else {
        updatedValues.push({ field_id: fieldId, field_value: value });
      }

      return updatedValues;
    });
  };
  const handleInputChangee = (id, fieldId, value) => {
    seteFormValues((prevValues) => {
      // Check if the field is already in formValues
      const existingFieldIndex = prevValues.findIndex(
        (field) => field.field_id === fieldId
      );

      // If the field is found, update its value; otherwise, add a new object to the array
      const updatedValues = [...prevValues];
      if (existingFieldIndex !== -1) {
        updatedValues[existingFieldIndex] = {
          id: id,
          field_id: fieldId,
          field_value: value,
        };
      } else {
        updatedValues.push({ id: id, field_id: fieldId, field_value: value });
      }

      return updatedValues;
    });
  };

  //api call for  trainer fields
  //api call for get trainer fields
  const getTrainingFields = async (id) => {
    setIsLoading(true);
    try {
      const result = await Services.getProfileTrainingFields(id);
      console.log(result);
      if (result) {
        setIsLoading(false);
        setFields(result?.data?.data?.fields);
      } else {
        toast.error(result.data.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getTrainingFields(activeid);
  }, [activeid]);
  // add new training field
  const addNewTrainingField = async () => {
    if (!fieldName) {
      toast.error("please eneter field name", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
    } else if (!fieldType) {
      toast.error("please eneter field type", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
    } else {
      setIsLoading(true);
      try {
        const result = await Services.addNewProfileTrainingField(
          activeid,
          fieldName,
          fieldType
        );
        console.log(result);
        if (result) {
          setIsLoading(false);
          setFieldName("");
          // setFieldType('')
          setNewFieldsModal(false);
          getTrainingFieldsValues(activeid);
          getTrainingFields(activeid);
        } else {
          toast.error(result.data.message, {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  // edit training field
  const editTrainingField = async () => {
    if (!fieldName) {
      toast.error("please eneter field name", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
    } else if (!fieldType) {
      toast.error("please eneter field type", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
    } else if (!fieldId) {
      toast.error("field id is required", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
    } else {
      setIsLoading(true);
      try {
        const result = await Services.editProfileTrainingField(
          fieldId,
          fieldName,
          fieldType,
          activeid
        );
        console.log(result);
        if (result) {
          toast.success(result.data.message, {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
          setIsLoading(false);
          setFieldName("");
          // setFieldType('')
          setNewFieldsModal(false);
          getTrainingFields(activeid);
          getTrainingFieldsValues(activeid);
          setIsEdit(false);
          setFieldId("");
        } else {
          toast.error(result.data.message, {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const editFieldFunction = (id, name, type) => {
    setFieldId(id);
    setIsEdit(true);
    setFieldName(name);
    setFieldType(type);
    setNewFieldsModal(true);
  };
  //delete trainer field

  const deleteTrainingField = async (id) => {
    setIsLoading(true);
    try {
      const result = await Services.deleteProfileTrainingField(id);
      console.log(result);
      if (result) {
        setIsLoading(false);
        toast.success(result.data.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
        getTrainingFields(activeid);
        getTrainingFieldsValues(activeid);
      } else {
        toast.error(result.data.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  //api call for  trainer fields values
  //api call for get values
  const getTrainingFieldsValues = async (id) => {
    setIsLoading(true);
    try {
      const result = await Services.getProfileTrainingFieldsValues(id);
      console.log("values", result);
      if (result) {
        setIsLoading(false);
        setFieldsValues(result?.data?.data);
      } else {
        toast.error(result.data.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getTrainingFieldsValues(activeid);
  }, [activeid]);

  //add profile training values
  const addTrainingFieldsValues = async () => {
    if (formValues.length === 0) {
      toast.error("please fill out fields", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
    } else {
      const data = { user_id: activeid, fields: formValues };
      setIsLoading(true);
      try {
        const result = await Services.addProfileTrainingFieldsValues(data);

        if (result) {
          setIsLoading(false);
          toast.success(result.data.message, {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
          getTrainingFieldsValues(activeid);
          setTrainerModal(false);
          setFormValues([]);
        } else {
          toast.error(result.data.message, {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  // edit field value function

  const editFieldValueFunction = (fields, id) => {
    setEditFieldId("");
    seteFields([]);
    fields?.map((field) =>
      seteFormValues((prevValues) => {
        // If the field is found, update its value; otherwise, add a new object to the array
        const updatedValues = [...prevValues];

        updatedValues.push({
          id: id,
          field_id: field.field_id,
          field_value: field.field_value,
        });

        return updatedValues;
      })
    );
    seteTrainerModal(true);
    seteFields(fields);
    setEditFieldId(id);
  };

  //edit training field values api call
  const editTrainingFieldsValues = async () => {
    if (eformValues.length === 0) {
      toast.error("please fill out fields", {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
    } else {
      const data = { id: editFieldId, user_id: activeid, fields: eformValues };
      setIsLoading(true);
      try {
        const result = await Services.editProfileTrainingFieldsValues(data);

        if (result) {
          setIsLoading(false);
          toast.success(result.data.message, {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
          getTrainingFieldsValues(activeid);
          seteTrainerModal(false);
          setFormValues([]);
          seteFormValues([]);
          setEditFieldId("");
          seteFields([]);
        } else {
          toast.error(result.data.message, {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  //delete training field value

  const deleteTrainingFieldValue = async (id, activeid) => {
    setIsLoading(true);
    try {
      const result = await Services.deleteProfileTrainingFieldsValue(
        id,
        activeid
      );

      if (result) {
        setIsLoading(false);
        toast.success(result.data.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
        getTrainingFieldsValues(activeid);
        getTrainingFields(activeid);
      } else {
        toast.error(result.data.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="trainings-wrapper-main">
      <ToastContainer />
      {isLoading && (
        <div className="loaderparent">
          <div className="loader"></div>
        </div>
      )}

      <div className="trainings-wrapper">
        {/* New fields modal */}
        {newFieldsModal && (
          <div className="excercise-modal trainings-modal add-field-modal mt-4 pt-4">
            <i
              className="fa fa-times"
              onClick={() => {
                setNewFieldsModal(false);
                setIsEdit(false);
              }}
            ></i>

            <div className="child-modal ">
              <p className="title-small">
                {isEdit ? "Edit field" : "Add new field"}
              </p>
              <div className="form-group">
                <label htmlFor="">Field name </label>
                <input
                  type="text"
                  value={fieldName}
                  onChange={(e) => setFieldName(e.target.value)}
                />
              </div>
              <div className="form-group">
                <label htmlFor="">New field type</label>
                <select
                  value={fieldType}
                  onChange={(e) => setFieldType(e.target.value)}
                >
                  <option>Please select</option>
                  <option value="text">Text</option>
                  <option value="number">Number</option>
                  <option value="date">Date</option>
                  <option value="select">Select</option>
                </select>
              </div>

              <div className="d-flex justify-content-center mt-3">
                {isEdit ? (
                  <button
                    className="button"
                    onClick={() => editTrainingField()}
                  >
                    Edit now
                  </button>
                ) : (
                  <button
                    className="button"
                    onClick={() => addNewTrainingField()}
                  >
                    Add now
                  </button>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Training edit fields modal modal */}
        {editFieldModal && (
          <div className="excercise-modal trainings-modal mt-4 pt-4">
            <i
              className="fa fa-times"
              onClick={() => setEditFieldModal(false)}
            ></i>

            <p className="title-small">Edit fields</p>
            <div className="child-modal ">
              <div className="cont">
                {fields?.map((field) => (
                  <div className="form-group linee  relative" key={field.id}>
                    <div className="actions">
                      <i
                        class="fa-solid fa-trash-can"
                        title="Delete field"
                        onClick={() => deleteTrainingField(field?.id)}
                      ></i>
                      <i
                        class="fa-solid fa-pen-to-square"
                        title="Edit field"
                        onClick={() =>
                          editFieldFunction(
                            field?.id,
                            field?.field_name,
                            field?.field_type
                          )
                        }
                      ></i>
                    </div>
                    <label htmlFor={`id${field.id}`}>{field.field_name}</label>
                  </div>
                ))}
              </div>
              <div className="d-flex justify-content-center mt-3">
                <button
                  className="button"
                  onClick={() => {
                    setNewFieldsModal((pre) => !pre);
                    setIsEdit(false);
                    setFieldName("");
                    setFieldType("");
                  }}
                >
                  Add new field
                </button>
              </div>
            </div>
          </div>
        )}
        {/* Training modal */}
        {trainermodal && (
          <div className="excercise-modal trainings-modal mt-4 pt-4">
            <i
              className="fa fa-times"
              onClick={() => {
                setTrainerModal(false);
                setFormValues([]);
              }}
            ></i>

            <p className="title-small">Add new record</p>
            <div className="child-modal ">
              <div className="cont">
                {fields?.map((field) => (
                  <div className="form-group relative" key={field.id}>
                    <label htmlFor={`id${field.id}`}>{field.field_name}</label>

                    {field?.field_type === "select" ? (
                      <select
                        id={`id${field.id}`}
                        type={field.field_type}
                        className="input"
                        value={
                          formValues.find((fv) => fv.field_id === field.id)
                            ?.field_value || ""
                        }
                        onChange={(e) =>
                          handleInputChange(field.id, e.target.value)
                        }
                      >
                        <option value="">Select yes/No</option>
                        <option value="yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    ) : (
                      <input
                        id={`id${field.id}`}
                        type={field.field_type}
                        className="input"
                        value={
                          formValues.find((fv) => fv.field_id === field.id)
                            ?.field_value || ""
                        }
                        onChange={(e) =>
                          handleInputChange(field.id, e.target.value)
                        }
                      />
                    )}
                  </div>
                ))}
              </div>
              <div className="d-flex justify-content-between mt-3">
                <button
                  className="button"
                  onClick={() => {
                    setNewFieldsModal((pre) => !pre);
                    setIsEdit(false);
                    setFieldName("");
                    setFieldType("");
                  }}
                >
                  Add new field
                </button>
                <button
                  className="button"
                  onClick={() => addTrainingFieldsValues()}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        )}

        {/* //edit trainer modal */}
        {etrainermodal && (
          <div className="excercise-modal trainings-modal mt-4 pt-4">
            <i
              className="fa fa-times"
              onClick={() => {
                seteTrainerModal(false);
                seteFormValues([]);
              }}
            ></i>

            <div className="child-modal ">
              <p className="title-small">Update Record</p>
              <div className="cont">
                {efields?.map((field) => (
                  <div className="form-group relative" key={field.id}>
                    {/* <div className="actions">
<i class="fa-solid fa-trash-can" onClick={()=>deleteTrainingField(field?.id)}></i>
<i class="fa-solid fa-pen-to-square" onClick={()=>editFieldFunction(field?.id,field?.field_name,field?.field_type)}></i>
</div> */}
                    <label htmlFor={`id${field.field_id}`}>
                      {field.field_name}
                    </label>
                    {field?.field_type === "select" ? (
                      <select
                        id={`id${field.field_id}`}
                        type={field?.field_type}
                        className="input"
                        value={
                          eformValues?.find(
                            (fv) => fv.field_id === field.field_id
                          )?.field_value || ""
                        }
                        onChange={(e) =>
                          handleInputChangee(
                            field.id,
                            field.field_id,
                            e.target.value
                          )
                        }
                      >
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    ) : (
                      <input
                        id={`id${field.field_id}`}
                        type={field?.field_type}
                        className="input"
                        value={
                          eformValues?.find(
                            (fv) => fv.field_id === field.field_id
                          )?.field_value || ""
                        }
                        onChange={(e) =>
                          handleInputChangee(
                            field.id,
                            field.field_id,
                            e.target.value
                          )
                        }
                      />
                    )}
                  </div>
                ))}
              </div>

              <div className="d-flex justify-content-center mt-3">
                <button
                  className="button"
                  onClick={() => editTrainingFieldsValues()}
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        )}
        <div className="trainings-main-wrapper">
          <div className="d-flex justify-content-between flexx">
            <div className="title-main">User trainings</div>
            <div className="d-flex">
              <button
                className="button me-3"
                onClick={() => setEditFieldModal(true)}
              >
                Manage fields
              </button>
              <button
                className="button"
                onClick={() => {
                  setTrainerModal(true);
                  setEditFieldModal(false);
                }}
              >
                Add New Record
              </button>
            </div>
          </div>

          <div className="table-responsive my-table mt-5">
            <table className="table">
              <thead>
                <tr>
                  {fields?.map((field, id) => (
                    <th>{field?.field_name}</th>
                  ))}
                  <th style={{ textAlign: "right" }}>actions</th>
                </tr>
              </thead>

              <tbody>
                {fieldsValues?.map((field) => (
                  <tr className="relative rel">
                    {" "}
                    {field?.fields?.map((f) => (
                      <>
                        <td>{f?.field_value ? f?.field_value : "N/A"}</td>{" "}
                      </>
                    ))}
                    <td>
                      <div className="actions">
                        <i
                          class="fa-solid fa-trash-can"
                          title="Delete field value"
                          onClick={() =>
                            deleteTrainingFieldValue(field?.id, activeid)
                          }
                        ></i>
                        <i
                          class="fa-solid fa-pen-to-square"
                          title="Edit field value"
                          onClick={() =>
                            editFieldValueFunction(field?.fields, field?.id)
                          }
                        ></i>
                      </div>
                    </td>{" "}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Trainings;
